import { TagsNetworkFilterController } from '../controller/TagsNetworkFilterController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class TagsNetworkFilterWebComponent extends BaseWebComponentElement {
  public controller!: TagsNetworkFilterController;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TagsNetworkFilterController,
    });
  }

  get value(): string {
    const value = this.getAttribute('value');

    if (value === null) {
      return '';
    }

    return value;
  }

  get selectedItems(): any[] {
    return this.controller.getSelectedItemsData();
  }

  async setSelectedItems(selectedItems: any[]): Promise<void> {
    await this.controller.setSelectedItemsData(selectedItems);
  }

  public set value(value: string) {
    this.setAttribute('value', value);

    // Re-render component when selected value changes
    this.propertiesSet = true;
  }

  set companyIds(value: Array<string>) {
    this.setAttribute('data-companyIds', JSON.stringify(value));
  }

  set companyNames(value: Array<string>) {
    this.setAttribute('data-companyNames', JSON.stringify(value));
  }

  set shouldFetchData(value: boolean) {
    this.setAttribute('should-fetch-data', JSON.stringify(value));
  }

  set label(value: string) {
    this.setAttribute('label', value);
  }

  set shouldUsePluralOnEmptyStateText(value: boolean) {
    this.setAttribute('shouldUsePluralOnEmptyStateText', JSON.stringify(value));
  }

  set labelWidth(value: string) {
    this.setAttribute('labelWidth', value);
  }

  set placeholder(value: string) {
    this.setAttribute('placeholder', value);
  }

  get companyIds(): Array<string> {
    const value = this.getAttribute('data-companyIds');

    if (value === null) {
      return [];
    }

    return JSON.parse(value);
  }

  get companyNames(): Array<string> {
    const value = this.getAttribute('data-companyNames');

    if (value === null) {
      return [];
    }

    return JSON.parse(value);
  }

  get shouldFetchData(): boolean {
    const value = this.getAttribute('should-fetch-data');
    return value ? JSON.parse(value) : true;
  }

  get shouldUsePluralOnEmptyStateText(): boolean {
    const value = this.getAttribute('shouldUsePluralOnEmptyStateText');
    return value ? JSON.parse(value) : false;
  }
}
